import axios from "axios";
import {getApiBaseUrl} from '../config/config'

const currentBaseURL = getApiBaseUrl();

const apiClient = axios.create({
  baseURL: `${currentBaseURL}/api`,
  headers: { 
    "Content-Type": "application/json"
  },
  timeout: 20000,
});

export default apiClient;
